export const compressImageForIOS = (base64Image, quality = 0.7, maxWidth = 1200) => {
  return new Promise((resolve) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();

    img.onload = () => {
      let { width, height } = img;

      // Resize if image is larger than maxWidth
      if (width > maxWidth) {
        height = (height * maxWidth) / width;
        width = maxWidth;
      }

      canvas.width = width;
      canvas.height = height;

      ctx.drawImage(img, 0, 0, width, height);

      const compressedBase64 = canvas.toDataURL("image/jpeg", quality);

      console.log("Image compressed:", {
        originalSize: base64Image.length,
        compressedSize: compressedBase64.length,
        reduction:
          (
            ((base64Image.length - compressedBase64.length) / base64Image.length) *
            100
          ).toFixed(1) + "%",
      });

      resolve(compressedBase64);
    };

    img.src = base64Image;
  });
};